var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const CancelFullScreen = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-cancel_full_screen ${className}`} {...other}>
      <g>
        <path d="M10 13.5h3.5V10a.5.5 0 01.5-.5h.5a.5.5 0 01.5.5v4a1 1 0 01-1 1h-4a.5.5 0 01-.5-.5V14a.5.5 0 01.5-.5zM1 6V2a1 1 0 011-1h4a.5.5 0 01.5.5V2a.5.5 0 01-.5.5H2.5V6a.5.5 0 01-.5.5h-.5A.5.5 0 011 6zm8.296 1.69a1 1 0 01-.993-.883l-.007-.12-.004-3.997a.5.5 0 01.5-.5h.48a.5.5 0 01.5.496l.02 2.484 3.755-3.814a.5.5 0 01.707-.005l.39.384a.5.5 0 01.005.707l-3.69 3.75 2.333-.001a.5.5 0 01.5.5v.5a.5.5 0 01-.5.5H9.296zm-2.577.613a1 1 0 01.993.883l.007.121-.022 3.994a.5.5 0 01-.5.497H6.72a.5.5 0 01-.5-.5l.002-2.475-3.768 3.821a.501.501 0 01-.708.005l-.39-.384a.5.5 0 01-.005-.707l3.704-3.756-2.337-.003a.5.5 0 01-.499-.5v-.5a.5.5 0 01.5-.5l4 .004z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default CancelFullScreen;
